import { Cms } from '@ankorstore/api-internal/Cms';
import type { GetCmsHeaderPillsData } from '@ankorstore/api-internal/data-contracts';
import { captureLoyaltyException } from '@core/plugins/sentry/helper';

export type CmsHeaderPillsAttributes = GetCmsHeaderPillsData['data']['attributes'];

// Promise-based cache to avoid duplicate concurrent requests (desktop + mobile mount simultaneously)
let cachedPromise: Promise<CmsHeaderPillsAttributes | null> | null = null;

export async function getCmsHeaderPills(): Promise<CmsHeaderPillsAttributes | null> {
  if (cachedPromise !== null) {
    return cachedPromise;
  }

  cachedPromise = (async () => {
    try {
      const cmsClient = new Cms();
      const response = await cmsClient.getCmsHeaderPills();
      return response?.data?.attributes ?? null;
    } catch (e) {
      captureLoyaltyException(e);
      cachedPromise = null;
      return null;
    }
  })();

  return cachedPromise;
}

export function clearHeaderPillsCache(): void {
  cachedPromise = null;
}
